import { ArrowPathIcon } from '@heroicons/react/24/outline'

interface LoadingStateProps {
  message?: string
}

export const LoadingState = ({
  message = 'Loading data...',
}: LoadingStateProps) => {
  return (
    <div className="flex items-center gap-3 text-sm text-base-content/70">
      <ArrowPathIcon className="w-4 h-4 animate-spin" aria-hidden />
      <span>{message}</span>
    </div>
  )
}
